import React from 'react';
import {Provider} from 'react-redux';

import {selectCategory, receiveCategories} from 'ducks/categories';

import {loadReact} from 'utils/dynamicLoader';
import CategoryList from 'components/category_list';

const initCategoryList = (selector, store) => {
    const element = document.querySelector(selector);

    if (!element) {
        return;
    }

    // Set selected category & root categories
    store.dispatch(selectCategory(DJ_CONST.SelectedCategory));
    store.dispatch(receiveCategories(DJ_CONST.RootCategoryList));

    const Component = (
        <Provider store={store}>
            <CategoryList />
        </Provider>
    );

    loadReact(element, Component);
};

export default (store) => {
    initCategoryList('#react-catalogue-categories', store);
};



// WEBPACK FOOTER //
// ./src/widgets/CatalogueCategoryList.js